import Vue from 'vue'
import Vuex from 'vuex'

import auth from '@/store/auth'
import user from '@/store/user'
import shop from '@/store/shop'
import product from '@/store/product'
// import access from '@/store/access'
import setting from '@/store/setting'

import bootstrap from './bootstrap'
Vue.use(Vuex)

const modules = {
  Auth: auth,
  User: user,
  Shop: shop,
  Product : product,
  // Access: access,
  Setting: setting,
  Bootstrap: bootstrap
}

export default new Vuex.Store({
  modules,
})
